import * as React from "react"

interface CheckboxIconProps extends React.SVGProps<SVGSVGElement> {
  isError?: boolean
}

const CheckboxIcon = (props: CheckboxIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <rect
      width={22.8}
      height={22.8}
      x={0.6}
      y={0.6}
      fill="#fff"
      stroke={props.isError ? "#C92418" : "#D1D5DB"}
      strokeWidth={1.2}
      rx={4.2}
    />
  </svg>
)
export default CheckboxIcon
